module.exports = __webpack_public_path__ + "static/media/map-book-shelf.06e87763.png";